import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  
  private skipUrls = [
    'flow-executions',
    'celery-task-log',
    'check-exists',
    'streamlit-template',
    'dashboard/status',
    'model-registry',
    'blocks/logs'
];

  constructor(private loadingService: LoadingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldSkip =
      this.skipUrls.some(url => req.url.includes(url)) ||
      (req.method === 'POST' && req.url.includes('/data'));
    if (shouldSkip) {
      return next.handle(req); 
    }

    this.loadingService.show();
    return next.handle(req).pipe(
      finalize(() => this.loadingService.hide())
    );
  }
}